import * as t from 'io-ts';

export const TeamMetadataChoices = t.interface({
  label: t.string,
  value: t.string,
});

export type BaseMetadataChoices = t.TypeOf<typeof TeamMetadataChoices>;

export const TeamMetadataValidation = t.interface({
  actions: t.interface({
    POST: t.interface({
      university: t.interface({
        choices: t.array(TeamMetadataChoices),
      }),
    }),
  }),
});

export const BaseTeamUserMemberIO = t.interface({
  email: t.string,
});

export const BaseTeamMembersElementIO = t.interface({
  user: BaseTeamUserMemberIO,
  weight: t.number,
});

export const BaseTeamElementIO = t.interface({
  name: t.string,
  type: t.string,
  members: t.array(BaseTeamMembersElementIO),
});

const NoConsultantTeamMemberIO = t.interface({
  email: t.string,
});

const NoConsultantTeamMembersIO = t.interface({
  user: NoConsultantTeamMemberIO,
});

export const NoConsultantTeamElementIO = t.interface({
  name: t.string,
  type: t.string,
  members: t.array(NoConsultantTeamMembersIO),
});

export const TeamElementIO = BaseTeamElementIO;
